(function () {
  'use strict';
  var root = document.querySelector('[data-millo-coins-product]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var config;
  try { config = JSON.parse(root.querySelector('[data-mcpd-config]').textContent); } catch (e) { return; }
  var EN = config.en, member = null, busy = false, refreshing = false, poll = 0, pollUntil = 0;
  var stateRequiresReload = false;
  var form = root.querySelector('[data-mcpd-form]'), buy = root.querySelector('[data-mcpd-buy]');
  var amount = root.querySelector('[data-mcpd-amount]'), bonus = root.querySelector('[data-mcpd-bonus]');
  var balance = root.querySelector('[data-mcpd-balance]'), status = root.querySelector('[data-mcpd-status]');
  var account = root.querySelector('[data-mcpd-account]'), historyList = root.querySelector('[data-mcpd-history]');
  var historyEmpty = root.querySelector('[data-mcpd-empty]'), historyError = root.querySelector('[data-mcpd-history-error]');
  var retry = root.querySelector('[data-mcpd-retry]');
  var pendingKey = 'millo-coins-checkout';
  function accountState(state) {
    if (account) { account.dataset.state = state; account.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false'); }
    if (historyError) historyError.hidden = state !== 'error';
    if (historyList) historyList.hidden = state === 'loading' || state === 'error';
    if ((state === 'loading' || state === 'error') && historyEmpty) historyEmpty.hidden = true;
    if (state === 'error' && balance) balance.textContent = '—';
    if (retry) {
      retry.disabled = state === 'loading';
      retry.textContent = stateRequiresReload ? (EN ? 'Reload page' : 'Recargar página') : (EN ? 'Try again' : 'Volver a intentar');
    }
  }
  function fmt(n) { return Number(n || 0).toLocaleString(EN ? 'en-US' : 'es-ES', {maximumFractionDigits: 0}); }
  function selected() { return form.querySelector('input[name="id"]:checked:not(:disabled)'); }
  function loginReturn(pack) {
    try {
      var page = new URL(location.href), login = new URL(config.login, page.origin);
      page.searchParams.set('variant', pack.value);
      var destination = page.pathname + page.search;
      if (!/^\/(?!\/)/.test(destination)) return config.login;
      var keys = ['return_to', 'return_url'].filter(function (key) { return login.searchParams.has(key); });
      if (!keys.length) keys = ['return_url'];
      keys.forEach(function (key) { login.searchParams.set(key, destination); });
      login.hash = '';
      return login.origin === page.origin ? login.pathname + login.search : login.href;
    } catch (e) { return config.login; }
  }
  function updatePack() {
    var pack = selected();
    if (!pack) { if (buy) buy.disabled = true; return; }
    var base = Number(pack.dataset.base), extra = Number(pack.dataset.member);
    amount.textContent = fmt(member === true ? extra : base);
    var price = root.querySelector('[data-mcpd-price]');
    if (price) price.textContent = pack.dataset.price;
    bonus.textContent = member === true
      ? (EN ? 'Your active membership includes the 50% bonus. Final eligibility is checked when payment is confirmed.' : 'Tu membresía activa incluye el 50 % de bonus. Se verifica al confirmarse el pago.')
      : (EN ? 'Millo Coins are exclusively for active members. Activate your membership before buying a pack.' : 'Los Millo Coins son exclusivos para miembros activos. Activa tu membresía antes de comprar un pack.');
    if (buy && !busy) buy.disabled = member !== true;
    try { var u = new URL(location.href); u.searchParams.set('variant', pack.value); history.replaceState(null, '', u); } catch (e) {}
    config.login = loginReturn(pack);
    var loginButton = form.querySelector('a[data-mcpd-login]');
    if (loginButton) loginButton.href = config.login;
  }
  root.querySelectorAll('[data-mcpd-pack-amount]').forEach(function (el) { el.textContent = fmt(el.textContent); });
  form.addEventListener('change', updatePack);
  updatePack();
  function renderHistory(movements) {
    var list = root.querySelector('[data-mcpd-history]'), empty = root.querySelector('[data-mcpd-empty]');
    if (!list) return;
    list.textContent = '';
    var rows = Array.isArray(movements) ? movements.slice().sort(function (a, b) { return String(b.f || '').localeCompare(String(a.f || '')); }).slice(0, 6) : [];
    if (empty) empty.hidden = !!rows.length;
    rows.forEach(function (row) {
      var li = document.createElement('li'), desc = document.createElement('span'), title = document.createElement('b'), meta = document.createElement('small'), n = document.createElement('span');
      title.textContent = row.t === 'recarga' ? (EN ? 'Millo Coins top-up' : 'Recarga de Millo Coins') : row.t === 'canje' ? (EN ? 'Experience redemption' : 'Canje de experiencia') : row.t === 'compra' ? (EN ? 'Purchase' : 'Compra') : row.t === 'cuota' ? (EN ? 'Membership' : 'Membresía') : row.t === 'reembolso' ? (EN ? 'Refund' : 'Reembolso') : (EN ? 'Balance activity' : 'Movimiento de saldo');
      var date = new Date(String(row.f || '').slice(0, 10) + 'T12:00:00');
      var label = isNaN(date.getTime()) ? '' : date.toLocaleDateString(EN ? 'en-GB' : 'es-ES', {day: 'numeric', month: 'short', year: 'numeric'});
      var concept = row.c || '', detail = row.d || '';
      if (EN) {
        concept = concept.replace(/^Pedido /, 'Order ').replace(/^Recarga de Millo Coins$/, 'Millo Coins top-up').replace(/^Cuota del club$/, 'Membership').replace(/^Canje$/, 'Redemption');
        detail = detail.replace(/^Recarga de Millo Coins/, 'Millo Coins top-up');
      }
      meta.textContent = [label, concept === title.textContent ? '' : concept, detail].filter(Boolean).join(' · ');
      n.textContent = (Number(row.n) < 0 ? '−' : '+') + fmt(Math.abs(Number(row.n) || 0));
      n.setAttribute('aria-label', n.textContent + ' Millo Coins');
      desc.appendChild(title); desc.appendChild(meta); li.appendChild(desc); li.appendChild(n); list.appendChild(li);
    });
  }
  function applyState(data) {
    var pending = data.pending === true || data.saldo_actualizandose === true;
    member = data.miembro_activo === true;
    if (balance) balance.textContent = fmt(data.saldo);
    if (status) status.textContent = pending
      ? (EN ? 'Updating your balance…' : 'Actualizando tu saldo…')
      : (EN ? 'Balance updated' : 'Saldo actualizado');
    renderHistory(data.movimientos);
    accountState(pending ? 'pending' : 'ready');
    updatePack();
    document.dispatchEvent(new CustomEvent('millo:estado', {detail: data}));
  }
  function refresh() {
    if (!config.loggedIn || refreshing) return Promise.resolve();
    if (stateRequiresReload) return Promise.resolve();
    if (!config.auth || !config.auth.f) {
      stateRequiresReload = true;
      accountState('error');
      if (status) status.textContent = EN ? 'Your balance could not be checked. Reload this page to try again.' : 'No se ha podido consultar tu saldo. Recarga la página para intentarlo otra vez.';
      return Promise.resolve();
    }
    refreshing = true;
    if (!account || account.dataset.state === 'loading' || account.dataset.state === 'error') accountState('loading');
    else account.setAttribute('aria-busy', 'true');
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 10000) : null;
    var options = {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({c: config.auth.c, ts: config.auth.ts, f: config.auth.f, tipo: 'estado'})};
    if (controller) options.signal = controller.signal;
    return fetch(config.auth.api, options).then(function (response) {
      if (response.status === 401) { stateRequiresReload = true; throw new Error('state-auth'); }
      return response.json().then(function (data) { if (!response.ok || !data.ok || !Number.isFinite(data.saldo)) throw new Error('state'); return data; });
    }).then(applyState).catch(function () {
      member = null; updatePack();
      accountState('error');
      if (status) status.textContent = stateRequiresReload
        ? (EN ? 'Your balance could not be checked. Reload this page to try again.' : 'No se ha podido consultar tu saldo. Recarga la página para intentarlo otra vez.')
        : (EN ? 'Your balance could not be checked. Please try again.' : 'No se ha podido consultar tu saldo. Inténtalo de nuevo.');
    }).then(function () { clearTimeout(timer); refreshing = false; });
  }
  function pendingCheckout() { try { return Date.now() - Number(sessionStorage.getItem(pendingKey) || 0) < 86400000; } catch (e) { return false; } }
  function startPolling() {
    if (!pendingCheckout() || poll) return;
    pollUntil = Date.now() + 60000;
    poll = setInterval(function () { if (Date.now() >= pollUntil) { clearInterval(poll); poll = 0; return; } if (!document.hidden) refresh(); }, 10000);
  }
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!config.loggedIn) { location.assign(config.login); return; }
    if (member !== true) { location.assign((window.MG_COINS_POLICY && window.MG_COINS_POLICY.club) || '/products/millo-gang-membership'); return; }
    var pack = selected();
    if (!pack || busy) return;
    busy = true; if (buy) buy.disabled = true;
    var error = root.querySelector('[data-mcpd-error]'); error.hidden = true;
    fetch(config.cartAdd, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(pack.value), quantity: 1}]})})
      .then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || 'cart'); return data; }); })
      .then(function () { try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (e) {} location.assign(config.checkout); })
      .catch(function () { busy = false; if (buy) buy.disabled = false; error.textContent = EN ? 'The pack could not be added. Please try again.' : 'No se ha podido añadir el pack. Inténtalo otra vez.'; error.hidden = false; });
  });
  if (retry) retry.addEventListener('click', function () {
    if (stateRequiresReload) { window.location.reload(); return; }
    refresh();
  });
  refresh(); startPolling();
  window.addEventListener('pageshow', function (event) { if (event.persisted) { busy = false; updatePack(); refresh(); startPolling(); } });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { refresh(); startPolling(); } });
})();
